import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'
import Moment from 'moment'
import Numeral from 'numeral'

import TextField from 'material-ui/TextField'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import Section from 'components/Section'
import AddPhoneButton from './AddPhoneButton'

let select = dirtyRead(
	(state, props) => ({
		vendor: doc(state, props.objectID)
	})
)

export class Phones extends Component{
	render(){
		let { props } = this
		return(
			<Section
				id="vendor/phones"
				title={"Phones"}
				rightButton={<AddPhoneButton objectID={props.objectID} />}
			>
			{props.vendor.phones && R.map((phone) =>(
				<div>
					<table style={{fontSize: "14px", width: "100%", marginLeft:"-2px"}}><tbody>
						<tr style={{height: "40px", width: "100%"}} >
							<td style={{width: "5px"}}></td>
							<td style={{textAlign: "left", width: "30%"}}>
								<TextField
									hintText = "Name"
									hintStyle={{fontStyle: "italic", fontSize: "14px"}}
									multiLine = {true}
									fullWidth={false}
									style={{
										width: "100%"
									  , position: "relative"
									  , marginTop: "-10px"
									  , marginLeft: "6px"
									  , display:"inline-block"
									}}
									inputStyle={{
										fontSize: "16px"
									}}
									underlineStyle={{
										left: "1px"
									  , borderBottom: "0px solid #b0bec4"
									}}
									floatingLabelStyle={{
										fontWeight: "100",
										fontSize: "14px"
									}}
									defaultValue={phone.name}
									key={phone.name}
									onBlur={(evt)=>{
										let i = R.indexOf(phone, props.vendor.phones)
										let NewName = {...props.vendor.phones[i], name: evt.target.value}
										let newPhones = [
											...props.vendor.phones.slice(0,i)
										  , NewName
										  , ...props.vendor.phones.slice(i+1)
										]
										this.props.STAGE({_id: props.vendor._id, phones: newPhones})
									}}
								/>
							</td>
							<td style={{width: "5px"}}></td>
							<td style={{textAlign: "left", width: "30%"}}>
								<TextField
									hintText = "Phone"
									hintStyle={{fontStyle: "italic", fontSize: "14px"}}
									multiLine = {true}
									fullWidth={false}
									style={{
										width: "100%"
									  , position: "relative"
									  , marginTop: "-10px"
									  , marginLeft: "6px"
									  , display:"inline-block"
									}}
									inputStyle={{
										fontSize: "16px"
									}}
									underlineStyle={{
										left: "1px"
									  , borderBottom: "0px solid #b0bec4"
									}}
									floatingLabelStyle={{
										fontWeight: "100",
										fontSize: "14px"
									}}
									defaultValue={phone.phoneNumber}
									key={phone.phoneNumber}
									onBlur={(evt)=>{
										let i = R.indexOf(phone, props.vendor.phones)
										let newPhone = {...props.vendor.phones[i], phoneNumber: evt.target.value}
										let newPhones = [
											...props.vendor.phones.slice(0,i)
										  , newPhone
										  , ...props.vendor.phones.slice(i+1)
										]
										this.props.STAGE({_id: props.vendor._id, phones: newPhones})
									}}
								/>
							</td>
							<td style={{width: "5px"}}></td>
							<td style={{textAlign: "left", width: "30%"}}>
								<TextField
									hintText = "Email"
									hintStyle={{fontStyle: "italic", fontSize: "14px"}}
									multiLine = {true}
									fullWidth={false}
									style={{
										width: "100%"
									  , position: "relative"
									  , marginTop: "-10px"
									  , marginLeft: "6px"
									  , display:"inline-block"
									}}
									inputStyle={{
										fontSize: "16px"
									}}
									underlineStyle={{
										left: "1px"
									  , borderBottom: "0px solid #b0bec4"
									}}
									floatingLabelStyle={{
										fontWeight: "100",
										fontSize: "14px"
									}}
									defaultValue={phone.email}
									key={phone.email}
									onBlur={(evt)=>{
										let i = R.indexOf(phone, props.vendor.phones)
										let newPhone = {...props.vendor.phones[i], email: evt.target.value}
										let newPhones = [
											...props.vendor.phones.slice(0,i)
										  , newPhone
										  , ...props.vendor.phones.slice(i+1)
										]
										this.props.STAGE({_id: props.vendor._id, phones: newPhones})
									}}
								/>
							</td>
							<td style={{position:"relative", left:"-1px", width: "30px", textAlign:"right"}}>
								<div style={{width: "30px", textAlign:"right"}}>
									<img src={"/manager/static/img/trash-red.png"}
										style={{
											height: "16px"
										  , cursor: "pointer"
										  , marginLeft: "5px"
										}}
										onClick={()=> {
											let i = R.indexOf(phone, props.vendor.phones)
											let cur = [
												...props.vendor.phones.slice(0,i)
											  , ...props.vendor.phones.slice(i+1)
											]
											props.STAGE({
												_id: props.objectID
											  , phones: cur
										  })
										}}
									/>
								</div>
							</td>
						</tr>
					</tbody></table>
					</div>
				), props.vendor.phones)}
			</Section>
		)
	}
}

export default connect(select, dataActions)(Phones)



// WEBPACK FOOTER //
// ./src/routes/manager/vendorForm/Phones.js